<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <loading :active.sync="isLoading"
                :can-cancel="false" :is-full-page="fullPage"></loading>
                <CForm @submit.prevent="loginUser">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    placeholder="Email"
                    autocomplete="username email"
                    v-model="login.email"
                  >
                    <template #prepend-content><CIcon name="cil-envelope-closed"/></template>
                  </CInput>
                  <div class="login-errors" v-if="$v.login.email.$error" style="marging-top: 0px;">
                    <span class="validation-error" v-if="!$v.login.email.required">Please Enter Email</span>
                    <span class="validation-error" v-else-if="!$v.login.email.email">Please Enter valid Email</span>
                  </div>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="login.password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <div class="login-errors" v-if="$v.login.password.$error">
                    <span class="validation-error" v-if="!$v.login.password.required">Please Enter password</span>
                    <span class="validation-error" v-else-if="!$v.login.password.minlength">Please Enter password minimum 6 characters</span>
                  </div>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" type="submit">Login</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                        <!-- <router-link to="/forgot-password" class="px-0">Forgot Password?</router-link> -->
                      <CButton color="link" class="d-lg-none">Register now!</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <!-- <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Sign up</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                >
                  Register Now!
                </CButton>
              </CCardBody>
            </CCard> -->
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import axios from 'axios'
import { validationMixin } from "vuelidate";
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
const {
    email,
    required,
    maxLength,
	minLength,
	sameAs
} = require("vuelidate/lib/validators");
export default {
    name: 'Login',
    data() {
        return {
            isLoading: false,
            fullPage: true,
            login: {
                email: "",
                password: ""
            }
        };
    },
    components: {
        Loading
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    mounted() {
        document.title = "Login";
        this.checkLoggedIn();
    },
    methods: {
        loginUser() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                try {
                    this.isLoading = true;
                    axios.post(`${API_ADMIN_URL}/login`, this.login).then(response => {
                        if (response.data.status == 200) {
                            const token = response.data.data.token
                            localStorage.setItem('token', JSON.stringify(response.data.data.token));
                            localStorage.setItem('userdata', JSON.stringify(response.data.data.user));
                            this.isLoading = false;
                            if (token) {
                                this.$router.push("/dashboard");
                            }
                        } else if (response.data.status == 400) {
                            this.showErrorMsg({message: response.data.message});
                            this.isLoading = false;
                        }
                        this.isLoading = false;
                    });
                } catch (err) {
                    this.showErrorMsg({message: 'Something went to wrong, please try again!'});
                }
            }
        },
        checkLoggedIn() {
            if (localStorage.getItem('userdata') != null)// && localStorage.getItem('token') != null
            {
                this.$router.push("/dashboard");
            }
        }
    },
    mixins: [validationMixin],
	validations: {
		login:{
			email: {
                email,
				required,
			},
			password: {
				required,
                minLength: minLength(6),
			}
    	}
    }
};
</script>
